import axios from 'axios'

// URL base dell'API per le firme delle petizioni, recuperato dall'env file

const FIRME_PETIZIONE_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'firme-petizione'

const headers = { 'Content-Type': 'application/json' }

class FirmePetizioneService {
    /**
     * Salva una firma di una petizione nel sistema.
     * Effettua una richiesta POST a `/firme-petizione/save` con i dati della firma.
     *
     * @param {Object} firma - Oggetto contenente i dettagli della firma da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    registraFirma(firma) {
        return axios.post(FIRME_PETIZIONE_REST_API_URL + "/save", firma, headers);
    }

     /**
     * Elimina una firma di una petizione nel sistema.
     * Effettua una richiesta POST a `/firme-petizione/delete` con i dati della firma.
     *
     * @param {Object} firma - Oggetto contenente i dettagli della firma da eliminare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    revocaFirma(firma) {
        return axios.post(FIRME_PETIZIONE_REST_API_URL + "/delete", firma, headers)
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const firmePetizioneServiceInstace = new FirmePetizioneService()
export default firmePetizioneServiceInstace;